import React from 'react';
import HeaderSection from '../components/HeroSection';
import Brands from '../components/Brands';
import ArticleHome from './ArticleHome';
import BrandsThatTrustUs from '../components/BrandsThatTrustUs';

const Home = () => {
  



  return (
    <>
      <HeaderSection />
      <div >
        <Brands />
        <ArticleHome />
        <BrandsThatTrustUs/>
      </div>
    </>
  );
};

export default Home;

